import * as t from 'io-ts';

import {makeDefaultValueType, makeEnumRuntimeType} from './apiTypes';

/*
 * Runtime type.
 */

export enum ChannelErrorLevelsEnum {
  WARNING = 'warning',
  ERROR = 'error',
}
const RChannelErrorLevel = makeEnumRuntimeType(ChannelErrorLevelsEnum);

// Highest-severity first.
export const channelErrorLevelPriority = [ChannelErrorLevelsEnum.ERROR, ChannelErrorLevelsEnum.WARNING];

const RChannelErrorDirty = t.readonly(
  t.type({
    type: t.string,
    level: makeDefaultValueType(RChannelErrorLevel, ChannelErrorLevelsEnum.ERROR),
    description: t.string,
    linkTarget: t.union([t.string, t.undefined]),
    linkCaption: t.union([t.string, t.undefined]),
  }),
);

/*
 * Type.
 */

export interface ChannelErrorModel extends t.TypeOf<typeof RChannelErrorDirty> {}
export const RChannelError = t.clean<ChannelErrorModel>(RChannelErrorDirty as any);

/*
 * IO methods.
 */

export function parseChannelError(src: any): ChannelErrorModel {
  return {
    type: src.error_type,
    level: src.error_level || ChannelErrorLevelsEnum.ERROR,
    description: src.error_desc || src.error_type,
    linkTarget: src.error_link || undefined,
    linkCaption: src.error_caption || undefined,
  };
}
